// EventsMarketingPage.jsx — Hauptseite events.tda-intl.org
//
// Seit 22.10.2026 die Veranstaltungsübersicht nach dem abgenommenen Muster
// (docs/muster-ausschreibung/muster.html): Liste mit Logo als Standard,
// Karten und Kalender zum Umschalten, hell und dunkel.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import Veranstaltungsuebersicht from '../components/oeffentlich/Veranstaltungsuebersicht';
import { useThema, ThemaKnopf, OeffentlicherFuss } from '../components/oeffentlich/ausschreibungTeile';
import '../styles/ausschreibung.css';

export default function EventsMarketingPage() {
  const { thema, wirksam, umschalten } = useThema();
  const [nlEmail, setNlEmail]     = useState('');
  const [nlName, setNlName]       = useState('');
  const [nlMsg, setNlMsg]         = useState(null); // { ok, text }
  const [nlLoading, setNlLoading] = useState(false);

  const handleNlSubmit = async (e) => {
    e.preventDefault();
    setNlLoading(true); setNlMsg(null);
    try {
      const r = await fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: nlEmail, name: nlName }),
      });
      const d = await r.json().catch(() => ({}));
      const ok = r.ok && d.success;
      setNlMsg({ ok, text: ok ? d.message : (d.error || `Fehler ${r.status}`) });
      if (ok) { setNlEmail(''); setNlName(''); }
    } catch { setNlMsg({ ok: false, text: 'Verbindungsfehler' }); }
    finally { setNlLoading(false); }
  };

  return (
    <div className="au" data-thema={thema || undefined}>
      <PublicNav />
      <main id="veranstaltungen">
        <Veranstaltungsuebersicht kopfZusatz={<ThemaKnopf wirksam={wirksam} umschalten={umschalten} />} />
      </main>

      <section className="au-wrap au-breit au-unten">
        <div className="au-unten-teil">
          <h2>Selbst ein Turnier ausrichten?</h2>
          <p>Online-Anmeldung, Live-Wertung und Siegerehrung aus einer Hand.</p>
          <p><Link to="/fuer-veranstalter">Für Veranstalter</Link> · <Link to="/ranking">Saison-Rangliste</Link></p>
        </div>
        <form className="au-unten-teil au-nl" onSubmit={handleNlSubmit}>
          <h2>Keine Veranstaltung verpassen</h2>
          <p>Neue Turniere und Termine per E-Mail.</p>
          <div className="au-nl-zeile">
            <input type="text" placeholder="Name (freiwillig)" aria-label="Name" value={nlName} onChange={(e) => setNlName(e.target.value)} />
            <input type="email" placeholder="E-Mail-Adresse" aria-label="E-Mail-Adresse" value={nlEmail} onChange={(e) => setNlEmail(e.target.value)} required />
            <button type="submit" className="au-knopf au-haupt" disabled={nlLoading}>{nlLoading ? 'Einen Moment …' : 'Eintragen'}</button>
          </div>
          {nlMsg && <div className={nlMsg.ok ? 'au-nl-ok' : 'au-nl-fehler'} role="status">{nlMsg.text}</div>}
        </form>
      </section>
      <OeffentlicherFuss />
    </div>
  );
}
